export default "__VITE_ASSET__BO$aSzJ3__"